import mixpanel from 'mixpanel-browser'
import ahaBigQ from '@/utils/mixpanel/ahabigq.mirror'

export const resetIdentityOfDifferentUser = (user) => {
  const identifiedUserId = mixpanel.get_property('$user_id')
  if (identifiedUserId && String(identifiedUserId) !== String(user.id)) {
    mixpanel.reset()
    ahaBigQ.reset()
  }
}
